import * as React from 'react';
import Panel from './Panel';
import {ActiveGame} from './AppTypes';

function gameStatus(game: ActiveGame): string {
    return game.round < 1 ? 'starting' : `round #${game.round}`;
}

export function ActiveGames({games}: {games?: ActiveGame[]}): JSX.Element {
    return (
        <Panel id="active-games-panel">
            <p>Active games</p>
            {(games || []).map((game, i) => (
                <div key={i}>
                    {game.mapName} ({gameStatus(game)})
                </div>
            ))}
        </Panel>
    );
}



// WEBPACK FOOTER //
// ./src/ActiveGames.tsx